import { GetOrganizationOrdersDocument } from "@/core/api/graphql/types";
import { globals } from "@/core/globals";
import { graphqlClient } from "../../../client";
import type { QueryOrganizationOrdersArgs, CustomerOrderConnection, Query } from "@/core/api/graphql/types";

export async function getOrganizationOrders(
  payload?: QueryOrganizationOrdersArgs,
): Promise<CustomerOrderConnection | undefined> {
  const { cultureName, organizationId } = globals;

  const { data } = await graphqlClient.query<Required<Pick<Query, "organizationOrders">>, QueryOrganizationOrdersArgs>({
    query: GetOrganizationOrdersDocument,
    variables: {
      cultureName,
      organizationId,
      ...payload,
    },
  });

  return data.organizationOrders;
}
